<template>
    <div id="authcode">
        <!-- -->
        <div v-for="param in authcode" :key="param.key">
            <span class="inputSpan">{{ param.key }}：</span>
            <el-input type="text" :value="param.value" />
            <el-button @click="copyToClipboard(param.value)" type="success" class="suc">复制</el-button>
        </div>
        <div style="justify-content: center;">
            <el-button @click="clearInput" type="danger">清空</el-button>
            <el-button @click="undoClear" type="primary">撤销清空</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'YinshiOffcialwebsiteauthcode',
    data() {
        return {
            authcode:[],
        };
    },

    mounted() {

    },
    created() {
        this.routerParam();
    },
    methods: {
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$message.success('复制成功');
            }).catch(() => {
                this.$message.error('复制失败');
            });
        },
        routerParam(){
            Object.keys(this.$route.query).forEach((key) => {
            this.authcode.push({
                key: key,
                value: this.$route.query[key],
            });
        });
        },  
        // 清空输入框
        clearInput() {
            this.authcode = [];
        },
        // 撤销清空
        undoClear() {
            this.authcode = [];
            this.routerParam();
        },
    },
};
</script>
<style lang="scss" scoped>
    .suc {
        margin: 10px 0 0 10px;
    }
    #authcode {
        padding: 20px;
        border-radius: 8px;
        width: 500px;
        margin:auto;
        div{
            display: flex;
            align-items: center;
            margin-top:10px;
        }
    }
    .inputSpan {
        font-size: 16px;
        color: #333;
        width: 100px;
        text-align: right;
        padding-right:5px;
        padding-top: 7px;
    }
    input {
        margin-left: 10px;
        padding: 5px;
        border-radius: 4px;
        border: 1px solid #ccc;
    }
</style>